import React from 'react';
import { Target, FileCheck, Building, Headphones } from 'lucide-react';
import { benefits } from '../../content';

const iconMap = {
  Target,
  FileCheck,
  Building,
  HeadphonesIcon: Headphones
};

// Valores por defecto
const defaultBenefits = {
  sectionLabel: "¿Por qué elegirnos?",
  sectionTitle: "Beneficios que nos distinguen",
  sectionSubtitle: "Nos comprometemos a brindarte la mejor experiencia",
  items: []
};

export const BenefitsSection = () => {
  // Obtener contenido con fallbacks
  const content = {
    sectionLabel: benefits?.sectionLabel || defaultBenefits.sectionLabel,
    sectionTitle: benefits?.sectionTitle || defaultBenefits.sectionTitle,
    sectionSubtitle: benefits?.sectionSubtitle || defaultBenefits.sectionSubtitle,
    items: benefits?.items || defaultBenefits.items
  };

  if (content.items.length === 0) return null;

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#CFA935] font-semibold text-sm uppercase tracking-wider">
            {content.sectionLabel}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#013C5D]">
            {content.sectionTitle}
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            {content.sectionSubtitle}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {content.items.map((benefit, idx) => {
            const Icon = iconMap[benefit.icon] || Target;
            return (
              <div
                key={benefit.id || idx}
                className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#CFA935]/30"
                style={{ animationDelay: `${idx * 100}ms` }}
              >
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#013C5D] to-[#025a8a] group-hover:from-[#CFA935] group-hover:to-[#b8942f] flex items-center justify-center mb-6 transition-all duration-300 shadow-lg">
                  <Icon className="w-10 h-10 text-[#CFA935] group-hover:text-[#013C5D] transition-colors duration-300" />
                </div>
                <h3 className="text-lg font-semibold text-[#013C5D] mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
